import { ThemeOverviewMS } from '@api';
import { useQueryParams } from '@terminal/hooks/use-query-params/useQueryParams';
import { queryKeys } from '@terminal/routes/query-params';
import { MSOverview } from '@terminal/views/theme-overview-ms/tab-content/overview/MSOverview';
import { useTranslation } from 'react-i18next';
import { MSCompanies } from './companies/MSCompanies';
import { MSEarnings } from './earnings/MSEarnings';
import { MSPerformance } from './performance/MSPerformance';

export const MSTabContent = ({ theme }: { theme: ThemeOverviewMS }) => {
  useTranslation([
    'chat',
    'common',
    'widget',
    'screener',
    'calendar',
    'earnings',
    'chart',
    'watchlistManager',
    'whatsNew',
    'insights',
    'stream',
    'analyze',
  ]);
  const { params } = useQueryParams();
  const activeTab = params[queryKeys.activeSubTab] || 'overview';

  switch (activeTab) {
    case 'overview':
      return <MSOverview theme={theme} />;
    case 'companies':
      return <MSCompanies theme={theme} />;
    case 'earnings':
      return <MSEarnings theme={theme} />;
    case 'performance':
      return <MSPerformance theme={theme} />;
    default:
      return null;
  }
};
